const DeletedPage = () => 'Page supprimée.';

export const HomePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/HomePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AboutPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/a-propos/AboutPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ActualitesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/actualites/ActualitesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ArticlePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/actualites/[slug]/ArticlePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AdminHomePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/accueil/AdminHomePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewsListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-actualites/NewsListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewNewsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-actualites/nouvelle/NewNewsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UpdateNewsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-actualites/[news_id]/UpdateNewsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AvisListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-avis/AvisListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewAvisPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-avis/nouvel-avis/NewAvisPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AvisPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-avis/[avis_id]/AvisPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CondoleanceListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-condoleances/CondoleanceListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CondoleancePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-condoleances/[condoleance_id]/CondoleancePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const EnterrementListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-enterrements/EnterrementListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewEnterrementPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-enterrements/nouvel-enterrement/NewEnterrementPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const EnterrementPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-enterrements/[enterrement_id]/EnterrementPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UsersListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/UsersListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewUserPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/nouvel-utilisateur/NewUserPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UserPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/[user_id]/UserPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AssuranceObsequesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/assurance-obseques/AssuranceObsequesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ComprendreUnDevisPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/assurance-obseques/comprendre-un-devis/ComprendreUnDevisPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ConseilsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/assurance-obseques/conseils/ConseilsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AssuranceDevisPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/assurance-obseques/devis/AssuranceDevisPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NosDeuxContratsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/assurance-obseques/nos-deux-contrats/NosDeuxContratsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ObtenirDevisPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/assurance-obseques/obtenir-un-devis/ObtenirDevisPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const PreparerObsequesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/assurance-obseques/preparer-ses-obseques/PreparerObsequesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const EnterrementsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/avis-de-deces/EnterrementsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CondoleanceFormPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/avis-de-deces/faire-une-condoleance/[nom_prenom]/CondoleanceFormPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ContactPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/contact/ContactPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const PrevoyancePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/contrats-obseques/PrevoyancePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CatalogueFleursPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/fleurs-et-plaques/catalogue-fleurs/CatalogueFleursPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CataloguePlaquesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/fleurs-et-plaques/catalogue-plaques/CataloguePlaquesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CommandeFleurissementPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/fleurs-et-plaques/commande-fleurissement/CommandeFleurissementPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const LivrerDesFleursPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/fleurs-et-plaques/livrer-des-fleurs/LivrerDesFleursPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const LoginPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/login/LoginPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const MarbreriePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/MarbreriePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ChoisirCaveauPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/choisir-un-caveau/ChoisirCaveauPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ChoisirMonumentPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/choisir-un-monument/ChoisirMonumentPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CommanderNettoyagePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/commander-un-nettoyage/CommanderNettoyagePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ConfigurerMonumentPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/configurer-monument/ConfigurerMonumentPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CouleursGranitPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/couleurs-de-granit/CouleursGranitPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const MarbrerieDevisPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/devis/MarbrerieDevisPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const EntretenirMonumentPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/entretenir-un-monument/EntretenirMonumentPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const RenoverSepulturePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/marbrerie/renover-une-sepulture/RenoverSepulturePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const MyAccountPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mon-compte/MyAccountPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const RequestPasswordPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mot-de-passe-oublie/RequestPasswordPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewPasswordPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mot-de-passe-oublie/nouveau-mot-de-passe/[token]/NewPasswordPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ObsequesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/ObsequesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CremationPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/cremation/CremationPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const DevisObsequesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/devis-obseques/DevisObsequesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const EtapesOrganisationPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/etapes-organisation-obseques/EtapesOrganisationPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const InhumationPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/inhumation/InhumationPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const IOCPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/inhumation-ou-cremation/IOCPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const TypesCeremoniePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/types-ceremonie/TypesCeremoniePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UrgenceDecesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/obseques/urgence-deces/UrgenceDecesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

const ROUTES = { HomePage, AboutPage, ActualitesPage, ArticlePage, AdminHomePage, NewsListPage, NewNewsPage, UpdateNewsPage, AvisListPage, NewAvisPage, AvisPage, CondoleanceListPage, CondoleancePage, EnterrementListPage, NewEnterrementPage, EnterrementPage, UsersListPage, NewUserPage, UserPage, AssuranceObsequesPage, ComprendreUnDevisPage, ConseilsPage, AssuranceDevisPage, NosDeuxContratsPage, ObtenirDevisPage, PreparerObsequesPage, EnterrementsPage, CondoleanceFormPage, ContactPage, PrevoyancePage, CatalogueFleursPage, CataloguePlaquesPage, CommandeFleurissementPage, LivrerDesFleursPage, LoginPage, MarbreriePage, ChoisirCaveauPage, ChoisirMonumentPage, CommanderNettoyagePage, ConfigurerMonumentPage, CouleursGranitPage, MarbrerieDevisPage, EntretenirMonumentPage, RenoverSepulturePage, MyAccountPage, RequestPasswordPage, NewPasswordPage, ObsequesPage, CremationPage, DevisObsequesPage, EtapesOrganisationPage, InhumationPage, IOCPage, TypesCeremoniePage, UrgenceDecesPage };
export default ROUTES;